import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type HeroSectionProps = {
  guaranteeEnabled: boolean;
};
export function HeroSection({
  guaranteeEnabled
}: HeroSectionProps) {
  return <header className="bg-blue-950 px-4 pb-6 pt-5 text-center md:px-10 md:pb-7 md:pt-6" data-id="element-83" data-mp="28u4ncn43lelf">
      <p className="text-[14px] font-extrabold uppercase tracking-[0.08em] text-teal-300 md:text-[16px]" data-id="element-84" data-mp="28vza86yxjgs5">
        ATLAS MIOFASCIAL™
      </p>
      <h1 className="mt-1.5 text-[22px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-white md:text-[31px]" data-id="element-85" data-mp="30k966hc7ltkj">
        La biblioteca visual de ejercicios y protocolos de rehabilitación miofascial para{' '}
        <span className="text-teal-300" data-id="element-86" data-mp="2rrfqiisuos65">kinesiólogos y fisioterapeutas</span>
      </h1>
      <p className="mx-auto mt-3 max-w-[580px] text-[14px] leading-[1.45] text-white md:text-[16px]" data-id="element-87" data-mp="3fht81fdt78mh">
        Accedé a ejercicios ilustrados paso a paso, dosificaciones, progresiones, regresiones y protocolos clínicos
        organizados por región corporal.
      </p>
      <p className="mx-auto mt-2.5 max-w-[560px] text-[13px] font-extrabold uppercase leading-tight text-amber-400 md:text-[15px]" data-id="element-88" data-mp="2begla15ss3zo">
        Todo en una colección profesional, práctica y visual.
      </p>

      <div className="mx-auto mt-3 max-w-[340px]" data-id="element-89" data-mp="2ke3fo30409j8">
        <ProductImage data-id="element-90" data-mp="2kcii04ii0ah5" />
      </div>

      <p className="mt-2 text-[16px] font-extrabold uppercase leading-tight text-white md:text-[19px]" data-id="element-91" data-mp="2z39cjkbh5nny">
        6 volúmenes + 5 bonos gratis
      </p>
      <p className="mt-1 text-[13px] font-extrabold uppercase leading-tight text-teal-300 md:text-[15px]" data-id="element-92" data-mp="2u451eo4zpfuz">
        440 páginas de recursos clínicos
      </p>

      <div className="mt-3.5" data-id="element-93" data-mp="334uu3iyyeq4h">
        <CtaButton mode="scroll" data-id="element-94" data-mp="335mfk0yu77h1">¡Quiero acceder al Atlas completo!</CtaButton>
      </div>
      <p className="mx-auto mt-3 max-w-[440px] text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-95" data-mp="1dqy3y1y2ltk2">
        {guaranteeEnabled && <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-300" aria-hidden data-id="element-96" data-mp="38tbbvvvvceq3" />}
        Acceso digital inmediato{guaranteeEnabled && ' · Garantía de 7 días'}
      </p>
    </header>;
}